export default __webpack_public_path__ + "static/media/project_list_icon.509e2213.svg";